angular.module('impactx.invoice').controller('CloseInvoiceVerificationCtrl', [
    '$scope',
    '$mdDialog',
    'dataGen',
    'TranslationService',
    'blhId',
    CloseInvoiceVerificationCtrl
]);

function CloseInvoiceVerificationCtrl($scope, $mdDialog, dataGen, TranslationService, blhId) {
    var ctrl = this;

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    ctrl.ok = function () {
        $mdDialog.hide($scope.data);
    };

    dataGen.postAsForm($scope, {blhId: blhId}, '/invoice/verification/checkclose').then(function () {
        if ($scope.trns) {
            $scope.trns.abort = TranslationService.get('abort');
        }
    });

}